import React from 'react';

function Contact() {
  return (

    <body>
    <h1>Contact Information</h1>
    <p><b> Company name:</b> Full Health Inc</p>
    <p><b> Email adress:</b> fullhealthcompanion@gmail.com </p>
    <p><b> Adress:</b> 18 bis, Rue taieb siala, menzah4 tunis, tunisia </p>


    </body>
  );
}

export default Contact;
